import { render } from "./UserListTableCellImage.vue?vue&type=template&id=b13e8176&scoped=true&ts=true"
import script from "./UserListTableCellImage.vue?vue&type=script&lang=ts"
export * from "./UserListTableCellImage.vue?vue&type=script&lang=ts"

import "./UserListTableCellImage.vue?vue&type=style&index=0&id=b13e8176&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b13e8176"]])

export default __exports__